/* eslint-disable complexity */
import moment from 'moment'
import { initialState } from './state'
import { PayloadAction } from '@reduxjs/toolkit'
import {
  ProjectFormDocumentationPayload,
  ProjectFormCertificationPayload,
  ProjectTaxDescriptionsPayload,
  ProjectFormKeysValue,
  ContentFormPayload,
  ProjectSliceType,
  CompanyDetails,
  Project,
  FilterProjectType,
} from 'src/core/models'

const reducers = {
  /* Create Project Reducers */
  setCreateProjectLoading: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.createProject.loading = action.payload
  },
  setCreateProjectSuccess: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.createProject.success = action.payload
  },
  setCreateProjectResponse: (
    state: ProjectSliceType, action: PayloadAction<{ id: number, volume_credits: number }>
  ) => {
    state.createProject.response = action.payload
  },
  resetProjectCreateState: (state: ProjectSliceType) => {
    state.createProject.loading = false
    state.createProject.success = false
  },
  resetProjectCreateAllState: (state: ProjectSliceType) => {
    state.createProject = initialState.createProject
  },

  /* Validate Project Id Reducers */
  setValidateProjectIdLoading: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.validateProjectId.loading = action.payload
  },
  setValidateProjectIdResponse: (state: ProjectSliceType, action: PayloadAction<any>) => {
    const data = action.payload
    if (['ERROR'].includes(data)) {
      state.validateProjectId.response = data
    } else {
      state.validateProjectId.response = { type: 'SUCCESS', name: data?.name }
      state.validateProjectId.project = action.payload
    }
  },
  resetValidateProjectId: (state: ProjectSliceType) => {
    state.validateProjectId = initialState.validateProjectId
  },

  /* Validate Project Id Reducers For Stock Sale */
  setValidateProjectIdForStockSaleLoading: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.validateProjectIdForStockSale.loading = action.payload
  },
  setValidateProjectIdForStockSaleResponse: (state: ProjectSliceType, action: PayloadAction<any>) => {
    const data = action.payload
    if (['ERROR'].includes(data)) {
      state.validateProjectIdForStockSale.response = data
    } else {
      state.validateProjectIdForStockSale.project = data
      state.validateProjectIdForStockSale.response = { type: 'SUCCESS', name: data?.name }
    }
  },
  resetValidateProjectIdForStockSale: (state: ProjectSliceType) => {
    state.validateProjectIdForStockSale = initialState.validateProjectIdForStockSale
  },

  /* Create Purchase Operation Reducers */
  setPurchaseOperationLoading: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.createPurchaseOperation.loading = action.payload
  },
  setPurchaseOperationSuccess: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.createPurchaseOperation.success = action.payload
  },
  setPurchaseOperationError: (state: ProjectSliceType, action: PayloadAction<any>) => {
    state.createPurchaseOperation.error = action.payload
  },
  resetPurchaseOperationSuccess: (state: ProjectSliceType) => {
    state.createPurchaseOperation = initialState.createPurchaseOperation
  },

  /* Create Purchase Operation Reducers */
  setBrokerageOperationLoading: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.createBrokerageOperation.loading = action.payload
  },
  setBrokerageOperationSuccess: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.createBrokerageOperation.success = action.payload
  },
  setBrokerageOperationError: (state: ProjectSliceType, action: PayloadAction<any>) => {
    state.createBrokerageOperation.error = action.payload
  },
  setBrokerageOperationNewLink: (state: ProjectSliceType, action: PayloadAction<string>) => {
    state.createBrokerageOperation.newPurchaseLink = action.payload
  },
  resetBrokerageOperationState: (state: ProjectSliceType) => {
    state.createBrokerageOperation = initialState.createBrokerageOperation
  },

  /* User Projects Reducers */
  setUserProjectsLoading: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.userProjects.loading = action.payload
  },
  setUserProjectsData: (state: ProjectSliceType, action: PayloadAction<Project[]>) => {
    state.userProjects.data = action.payload
  },
  setUserProjectsFilterText: (state: ProjectSliceType, action: PayloadAction<string>) => {
    state.userProjects.filterText = action.payload
  },
  setUserProjectsFilterType: (state: ProjectSliceType, action: PayloadAction<FilterProjectType>) => {
    state.userProjects.filterType = action.payload
  },
  resetUserProjectsState: (state: ProjectSliceType) => {
    state.userProjects = initialState.userProjects
  },

  /* Project Details Reducers */
  setProjectDetailsLoading: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.projectDetails.loading = action.payload
  },
  setProjectDetailsData: (state: ProjectSliceType, action: PayloadAction<Project>) => {
    state.projectDetails.project = action.payload
  },
  resetProjectDetailsState: (state: ProjectSliceType) => {
    state.projectDetails = initialState.projectDetails
  },

  /* Create Purchase Operation Reducers */
  setTransferProjectLoading: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.transferProject.loading = action.payload
  },
  setTransferProjectSuccess: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.transferProject.success = action.payload
  },
  setTransferProjectError: (state: ProjectSliceType, action: PayloadAction<any>) => {
    state.transferProject.error = action.payload
  },
  resetTransferProjectState: (state: ProjectSliceType) => {
    state.transferProject = initialState.transferProject
  },

  // Project Form Reducers

  // Create Big Project Reducers
  setCreateBigProjectLoading: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.createBigProject.loading = action.payload
  },
  setCreateBigProjectNewId: (state: ProjectSliceType, action: PayloadAction<number>) => {
    state.createBigProject.newProjectId = action.payload
  },
  setCreateBigProjectError: (state: ProjectSliceType, action: PayloadAction<any>) => {
    state.createBigProject.error = action.payload
  },
  resetCreateBigProjectState: (state: ProjectSliceType) => {
    state.createBigProject = initialState.createBigProject
  },

  // Edit Big Project Selector
  setEditBigProjectLoading: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.editBigProject.loading = action.payload
  },
  setEditBigProjectSuccess: (state: ProjectSliceType, action: PayloadAction<boolean>) => {
    state.editBigProject.success = action.payload
  },
  setEditBigProjectError: (state: ProjectSliceType, action: PayloadAction<any>) => {
    state.editBigProject.error = action.payload
  },
  resetEditBigProjectState: (state: ProjectSliceType) => {
    state.editBigProject = initialState.editBigProject
  },

  setProjectFormItemValue: (state: ProjectSliceType, action: PayloadAction<ProjectFormKeysValue>) => {
    const { key, value } = action.payload
    state.projectForm[String(key)] = value
  },

  // Configurations
  restFormKindChanged: (state: ProjectSliceType) => {
    state.projectForm = { ...initialState.projectForm, kind: state.projectForm.kind }
  },
  resetProjectFormState: (state: ProjectSliceType) => {
    state.projectForm = initialState.projectForm
  },

  // Content
  setProjectFormContentValues: (state: ProjectSliceType, action: PayloadAction<ContentFormPayload>) => {
    const values = action.payload
    state.projectForm.name = values.name
    state.projectForm.url = values.url
    state.projectForm.sdg_compliances = values.sdg_compliances
    state.projectForm.description_en = values.description_en || null
    state.projectForm.description_es = values.description_es || null
    state.projectForm.description_fr = values.description_fr || null
    state.projectForm.description_ko = values.description_ko || null
    state.projectForm.description_de = values.description_de || null
    state.projectForm.description_pt = values.description_pt || null
    state.projectForm.description_it = values.description_it || null
    state.projectForm.registered_since = values.registered_since ? moment(values.registered_since).format('YYYY-MM-DD') : null
    state.projectForm.video = values.video
    state.projectForm.main_image = !values.main_image ? null : typeof values.main_image === 'string' ? values.main_image : URL.createObjectURL(values.main_image)
    state.projectForm.headline_en = values.headline_en || null
    state.projectForm.headline_es = values.headline_es || null
    state.projectForm.headline_fr = values.headline_fr || null
    state.projectForm.headline_ko = values.headline_ko || null
    state.projectForm.headline_de = values.headline_de || null
    state.projectForm.headline_pt = values.headline_pt || null
    state.projectForm.headline_it = values.headline_it || null
    state.projectForm.headline_pl = values.headline_pl || null
    state.projectForm.headline_zh = values.headline_zh || null
  },

  // Tax Relief
  setProjectFormTaxDescriptionsValue: (
    state: ProjectSliceType, action: PayloadAction<ProjectTaxDescriptionsPayload>
  ) => {
    state.projectForm.tax_info_en = action.payload.tax_info_en || null
    state.projectForm.tax_info_es = action.payload.tax_info_es || null
    state.projectForm.tax_info_fr = action.payload.tax_info_fr || null
    state.projectForm.tax_info_ko = action.payload.tax_info_ko || null
    state.projectForm.tax_info_de = action.payload.tax_info_de || null
    state.projectForm.tax_info_pt = action.payload.tax_info_pt || null
    state.projectForm.tax_info_it = action.payload.tax_info_it || null
    state.projectForm.tax_info_pl = action.payload.tax_info_pl || null
    state.projectForm.tax_info_zh = action.payload.tax_info_zh || null
  },

  // Certifications
  // eslint-disable-next-line complexity
  setCertificationFormValues: (state: ProjectSliceType, action: PayloadAction<ProjectFormCertificationPayload>) => {
    const values = action.payload
    state.projectForm.status = values.status || null
    state.projectForm.type = values.type || null
    state.projectForm.sub_type = values.sub_type || null
    state.projectForm.methodology = values.methodology || null
    state.projectForm.energy_type = values.energy_type || null
    state.projectForm.central_name = values.central_name || null
    state.projectForm.standard_energy_type = values.standard_energy_type || null
    state.projectForm.validator = values.validator || null
    state.projectForm.stage = values.stage || null
    state.projectForm.first_verifier = values.first_verifier || null
    state.projectForm.standard = values.standard || null
    state.projectForm.credit_start = values.credit_start ? moment(values.credit_start).format('YYYY-MM-DD') : null
    state.projectForm.credit_end = values.credit_end ? moment(values.credit_end).format('YYYY-MM-DD') : null
  },

  // Documentation
  setDocumentationPayload: (state: ProjectSliceType, action: PayloadAction<ProjectFormDocumentationPayload>) => {
    const values = action.payload
    state.projectForm.registry_depositing_id = values.registry_depositing_id || null
    state.projectForm.registry_depositing_name = values.registry_depositing_name || null
    state.projectForm.registry_depositing_url = values.registry_depositing_url || null
    state.projectForm.credits_certificate = values.credits_certificate || null
    state.projectForm.pdd = values.pdd || null
    state.projectForm.validation_report = values.validation_report || null
    state.projectForm.monitoring_report = values.monitoring_report || null
    state.projectForm.verification_report = values.verification_report || null
    state.projectForm.insurance_documentation = values.insurance_documentation || null
  },

  // Configuration Section
  setBillingPayloadForCreate: (state: ProjectSliceType, action: PayloadAction<CompanyDetails>) => {
    const company = action.payload
    state.projectForm.billing_company_name = company.name || null
    state.projectForm.billing_vat_number = company.id_number || null
    state.projectForm.billing_address = company.street && company.address ? `${company.street} ${company.address}` : null
    state.projectForm.billing_city = company.city || null
    state.projectForm.billing_state = company.state || null
    state.projectForm.billing_postal_code = company.postal_code || null
    state.projectForm.billing_country = company.country || null
  },

  // Edit Project Reducers
  setFormDataValues: (state: ProjectSliceType, action: PayloadAction<Project>) => {
    const oldState = state.projectForm
    const project = action.payload
    state.projectForm = {
      ...oldState,
      ...project,
      volume_credits: +project.co2_balance,
      country: project.country?.id || null,
      sdg_compliances: project.sdg_compliances.length === 0 ? [] : project.sdg_compliances.map(sdg => sdg.id),
      description_en: project.descriptions.find(desc => desc.language === 'en')?.text || null,
      description_es: project.descriptions.find(desc => desc.language === 'es')?.text || null,
      description_fr: project.descriptions.find(desc => desc.language === 'fr')?.text || null,
      description_ko: project.descriptions.find(desc => desc.language === 'ko')?.text || null,
      description_pt: project.descriptions.find(desc => desc.language === 'pt')?.text || null,
      description_de: project.descriptions.find(desc => desc.language === 'de')?.text || null,
      description_it: project.descriptions.find(desc => desc.language === 'it')?.text || null,
      description_pl: project.descriptions.find(desc => desc.language === 'pl')?.text || null,
      description_zh: project.descriptions.find(desc => desc.language === 'zh')?.text || null,
      registered_since: project.registered_since?.toString(),
      pictures: project.pictures.map(picture => picture.image),
      contributionProjectType: project.is_free_donation ? 'FREE_DONATION' : 'CONTRIBUTION_UNIT',
      vintage_items: project.vintage_items.length === 0 ? [] : project.vintage_items.map((vintage) => ({
        id: vintage.id,
        year: vintage.year,
        price: vintage.price,
        stock: vintage.stock_balance || vintage.available_volume_credits,
        delivery_date: vintage.delivery_date
      })),
      credit_start: project.credit_start?.toString(),
      credit_end: project.credit_end?.toString(),
    }
  },
}

export default reducers
